import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LookupPartType } from '../../../../../_shared/models/lookup.model';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-select-service-parts-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoPipe],
  templateUrl: './select-service-parts-modal.component.html',
  styleUrl: './select-service-parts-modal.component.scss'
})
export class SelectServicePartsModalComponent {
  @Input() selectedPartIds: number[] = [];
  @Input() partTypes: LookupPartType[] = [];

  searchTerm: string = '';
  tempSelectedPartIds: Set<number> = new Set();

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.tempSelectedPartIds = new Set(this.selectedPartIds);
  }

  get filteredParts(): LookupPartType[] {
    const q = this.searchTerm.trim().toLowerCase();
    if (!q) return this.partTypes;
    return this.partTypes.filter(p =>
      p.name.toLowerCase().includes(q)
    );
  }

  get selectedCount(): number {
    return this.tempSelectedPartIds.size;
  }

  isPartSelected(partId: number): boolean {
    return this.tempSelectedPartIds.has(partId);
  }

  togglePart(partId: number): void {
    if (this.tempSelectedPartIds.has(partId)) {
      this.tempSelectedPartIds.delete(partId);
    } else {
      this.tempSelectedPartIds.add(partId);
    }
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onAddParts(): void {
    const selectedParts = this.partTypes.filter(p => this.tempSelectedPartIds.has(p.id));
    this.activeModal.close(selectedParts);
  }
}